import { decimalStringToNumber, isValidDecimalString } from 'commons/utils/string'

export const decimalToString = (value: number): string => {
  if (value == 0) return ''
  else if (`${value}`.replace('.', ',').indexOf(',') === 0)
    return `0${value}`.replace('.', ',')
  else return `${value}`.replace('.', ',')
}

export const handleDiscountInput = (
  value: string | number,
  currentDiscountValue: number
): number => {
  if (value === '') return 0
  const newValue = decimalToString(value as number)

  if (!isValidDecimalString(newValue)) return currentDiscountValue

  const valueAsNumber = decimalStringToNumber(newValue)

  if (valueAsNumber > 99.99) {
    return 99.99
  } else if (valueAsNumber < 0) {
    return 0
  } else {
    return valueAsNumber
  }
}
